import { getDisplayDate } from "./GetDisplayDate";

export const normalizePrintData = (data) => {
  /* ---------- FLAGS ---------- */
  const isAEPS = Boolean(data.aeps_txn_mode || data.aeps_AadhaarNo);

  // Indo-Nepal: detected from IndoNepalReports fields OR Recent Transactions transactionType
  const isIndoNepal =
    data.prabhuPinNo  !== undefined ||
    data.partnerPinNo !== undefined ||
    data.transactionType === "INDO_NEPAL";

  const operatorName =
    data.operator ||
    data.operatorName ||
    data.billOperator ||
    data.serviceOperator ||
    null;

  const isOperatorTxn = Boolean(operatorName);
  const isBillerTxn   = Boolean(data.biller_Id || data.consumer_number);

  /* ---------- INDO-NEPAL: resolve both data shapes ----------
   *  IndoNepalReports shape  → prabhuPinNo, partnerPinNo, senderName, senderMobile,
   *                             receiverName, sendAmount, serviceCharge, payAmount, exchangeRate
   *  Recent Transactions shape → externalRefNo (PIN), thirdPartyTxnId (partnerPIN),
   *                              fullName (sender), consumerOrBeneficiary (receiver),
   *                              txnAmount (send), netAmount-txnAmount (service charge),
   *                              no NPR amount / no exchange rate
   */
  const inPrabhuPinNo   = data.prabhuPinNo   || data.externalRefNo       || null;
  const inPartnerPinNo  = data.partnerPinNo  || data.thirdPartyTxnId     || null;
  const inCustomerId    = data.senderCustomerId                            || null;
  const inSenderName    = data.senderName    || data.fullName             || null;
  const inSenderMobile  = data.senderMobile                               || null;
  const inReceiverName  = data.receiverName  || data.consumerOrBeneficiary|| null;
  const inSendAmount    = Number(data.sendAmount   || data.txnAmount  || 0).toFixed(2);
  const inServiceCharge = Number(
    data.serviceCharge !== undefined
      ? data.serviceCharge
      : (data.netAmount && data.txnAmount ? data.netAmount - data.txnAmount : 0)
  ).toFixed(2);
  const inPayAmountNPR  = data.payAmount   != null ? Number(data.payAmount).toFixed(2)   : null;
  const inExchangeRate  = data.exchangeRate != null ? Number(data.exchangeRate).toFixed(4) : "1.6000";

  /* ---------- NORMALIZED DATA ---------- */
  return {
    /* SHOP */
    shopName:   data.shopName   || data.merchantName,
    shopMobile: data.merchant_mobile || data.merchantMobileNumber,

    /* AMOUNT / STATUS */
    amount: isIndoNepal
      ? inSendAmount
      : (data.netAmount || data.amount),
    status: (data.status || data.txnStatus || "").toUpperCase(),

    /* TXN INFO */
    date: isIndoNepal
      ? getDisplayDate(data.createdAt || data.date)
      : getDisplayDate(data.rawDate   || data.date),
    txnId: isIndoNepal ? (inPrabhuPinNo || "—") : data.txnId,
    mode:  data.paymentMode || data.aeps_txn_mode,

    /* FLAGS */
    isAEPS,
    isOperatorTxn,
    isBillerTxn,
    isIndoNepal,

    /* INDO-NEPAL */
    inPrabhuPinNo,
    inPartnerPinNo,
    inCustomerId,
    inSenderName,
    inSenderMobile,
    inReceiverName,
    inSendAmount,
    inServiceCharge,
    inPayAmountNPR,   // null when not available (Recent Transactions)
    inExchangeRate,   // null when not available (Recent Transactions)

    /* OPERATOR */
    operatorName,
    consumerNumber: data.consumerNumber,

    /* BILLER */
    billerId:             data.biller_Id,
    billerConsumerNumber: data.consumer_number,

    /* CUSTOMER */
    customerName: isIndoNepal
      ? inSenderName
      : (data.customerName || data.remitterName),
    customerMobile: isIndoNepal
      ? inSenderMobile
      : (data.customerMobile || data.remitterMobileNumber),

    /* AEPS CUSTOMER */
    aadhaar:    data.aeps_AadhaarNo,
    aepsMobile: data.beneficiaryMobileNumber,

    /* BENEFICIARY */
    beneficiaryName: data.beneficiary_name || data.beneficiaryName,
    beneficiaryAccount:
      data.beneficiary_account_number || data.beneficiaryAccountNo,
    beneficiaryIFSC: data.beneficiary_ifsc_code,
    bankname : data.beneBankName,
    bankRrn: data.bankRrn || data.bank_rrn || null,
    beneficiaryName: isIndoNepal
      ? inReceiverName
      : (data.beneficiary_name || data.beneficiaryName),
    beneficiaryAccount: isIndoNepal
      ? (inPartnerPinNo || "")
      : (data.beneficiary_account_number || data.beneficiaryAccountNo),
    beneficiaryIFSC: isIndoNepal ? "" : data.beneficiary_ifsc_code,
    bankname:        isIndoNepal ? "" : data.beneBankName,
  };
};
